import { defineQuery } from 'next-sanity'
import { linkFields } from '../atoms'

export const careersPrefooterLinksBlockFields = `
  _id,
  _type,
  prefooterLinks[]{
    _key,
    linkTitle,
    "pageLink": pageLink{
      ${linkFields}
    },
    backgroundColour
  }
`

export const CAREERS_PREFOOTER_LINKS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-prefooter-links-block"][0]{
    ${careersPrefooterLinksBlockFields}
  }
`)
